import HeaderMain from '@/ui_app/components/header/HeaderMain.vue';
export default {
    setup: function () {
        return {};
    },
    components: { HeaderMain: HeaderMain }
};
